import styled, { css } from 'styled-components';

import { caption, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

import { NoteCorner, NOTE_CORNER_SIZE } from './NoteCorner';
import { ResizableTextArea } from './ResizableTextArea';

export const NoteWrapper = styled.div<{ $collapsed: boolean; $minHeight: number }>`
  display: flex;
  flex-direction: column;
  position: relative;

  background: ${colors.mustard20};
  border: ${spacing.single} solid ${colors.mustard100};
  border-radius: ${spacing.quarter};
  color: ${colors.textPrimary};

  div:hover + button {
    opacity: 100%;
  }
  min-height: ${({ $minHeight }) => pxToRem($minHeight)};
  max-height: ${pxToRem(186)};
  margin-bottom: ${spacing.double};
  padding: ${spacing.base} ${spacing.half} ${pxToRem(NOTE_CORNER_SIZE)};

  /** This cuts off the bottom right corner by 29px, to allow for the folder corner */
  clip-path: polygon(
    0% 0%,
    100% 0%,
    100% calc(100% - ${pxToRem(NOTE_CORNER_SIZE)}),
    calc(100% - ${pxToRem(NOTE_CORNER_SIZE)}) 100%,
    0% 100%
  );

  ${({ $collapsed }) => {
    return (
      $collapsed &&
      css`
        color: ${colors.textSecondary};
        background: ${colors.mustard10};
        border: ${spacing.single} solid ${colors.mustard50};
      `
    );
  }}
`;

export const StyledResizableTextArea = styled(ResizableTextArea)`
  flex: 1 1 auto;
  background: transparent;
  border: none;
  height: 100%;
  overflow-y: auto;
  width: 100%;

  :focus {
    outline: none;
  }

  /* Chrome, Firefox, Opera, Safari 10.1+  and  Microsoft Edge */
  /* stylelint-disable selector-no-vendor-prefix */
  ::placeholder,
  ::-ms-input-placeholder {
    color: ${colors.textSecondary};
  }
`;

export const TrashButton = styled.button`
  opacity: 0%;
  width: ${spacing.plusHalf};
  height: ${spacing.plusHalf};
  border-radius: 50%;
  padding: 0;
  padding-top: ${spacing.quarter};
  background: ${colors.red100};
  border: none;
  outline: none;

  :hover,
  :focus {
    opacity: 100%;
  }

  ${NoteWrapper}:hover ~ & {
    opacity: 100%;
  }

  ${NoteWrapper}:focus ~ & {
    opacity: 100%;
  }

  position: absolute;
  right: ${spacing.quarter};
  top: ${spacing.threeQuarter};
`;

// The styled folded corner of the note
export const StyledNoteCorner = styled(NoteCorner)`
  position: absolute;
  right: -0.33rem;
  bottom: -0.33rem;
`;

export const StyledCharacterCount = styled.p`
  ${caption}
  position: absolute;
  color: ${colors.mustard100};
  left: ${spacing.half};
  bottom: ${spacing.half};
  margin-bottom: 0;
`;
